<template>
  <div class="hpmepage-top-ad" v-if="isShow && ad && ad.indexBanner">
    <div class="ad-link">
      <span class="iconfont" @click="isShow = false">&#xe606;</span>
      <a :href="ad.indexBanner.link || ''" target="_blanck">
        <img :src="ad.indexBanner.img || ''" alt class="ad-img">
      </a>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      isShow: true
    };
  },
  methods: {},
  computed: {
    ad () {
      return this.$store.state.advertisement;
    }
  }
};
</script>

<style lang="less" scoped>
.hpmepage-top-ad {
  width: 100%;
  margin-top: 20px;
  height: 80px;
  .ad-link {
    width: 1200px;
    display: block;
    margin: 0 auto;
    height: 100%;
    position: relative;
    &::after {
      content: "广告";
      display: block;
      position: absolute;
      bottom: 0;
      right: 10px;
      background-color: rgba(77, 77, 77, 0.616);
      color: #fff;
      padding: 2px;
      font-size: 12px;
      padding-bottom: 0;
    }
    .iconfont {
      cursor: pointer;
      color: #fff;
      position: absolute;
      top: 0;
      right: 0px;
      padding: 2px;
      background-color: rgba(48, 48, 48, 0.541);
    }
    .ad-img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
